"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = exports.NOTIFICATION_SEMANTIC = void 0;
var React = _interopRequireWildcard(require("react"));
var _typography = require("../../types/typography");
var _classify = require("../../utils/classify");
var _qa = require("../../utils/qa");
var _Icon = require("../Icon");
var _Text = require("../Text");
var _NotificationModule = _interopRequireDefault(require("./Notification.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const NOTIFICATION_SEMANTIC = exports.NOTIFICATION_SEMANTIC = Object.freeze({
  success: 'success',
  information: 'information',
  danger: 'danger'
});
// Base Notification will not have any state.

const BaseNotification = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    classNames,
    semantic = NOTIFICATION_SEMANTIC.success,
    iconLeftName,
    iconLeftType = 'regular',
    dismissable,
    children,
    onCloseClick,
    testId
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classify.classify)(_NotificationModule.default.baseContainer, {
      [_NotificationModule.default.success]: semantic === NOTIFICATION_SEMANTIC.success,
      [_NotificationModule.default.information]: semantic === NOTIFICATION_SEMANTIC.information,
      [_NotificationModule.default.danger]: semantic === NOTIFICATION_SEMANTIC.danger,
      [_NotificationModule.default.dismissable]: dismissable
    }, classNames?.wrapper),
    ref: ref,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'root'
    }),
    children: [iconLeftName ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      name: iconLeftName,
      color: _typography.TEXT_COLORS.inversePrimary,
      size: "small",
      type: iconLeftType,
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: 'icon'
      })
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.SubTitleSmall, {
      className: (0, _classify.classify)(classNames?.text),
      color: _typography.TEXT_COLORS.inversePrimary,
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: 'text'
      }),
      children: children
    }), dismissable && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      color: _typography.TEXT_COLORS.inversePrimary,
      name: "close",
      size: "small",
      type: "regular",
      onClick: onCloseClick,
      className: _NotificationModule.default.closeIcon,
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: 'close'
      })
    })]
  });
});
const Notification = exports.Notification = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    classNames,
    semantic = NOTIFICATION_SEMANTIC.success,
    iconLeftName,
    iconLeftType,
    dismissable,
    children,
    onCloseClick,
    testId
  } = props;

  // Type narrowing to safely access selfDismiss only when dismissable is true
  const selfDismiss = dismissable === true && 'selfDismiss' in props ? props.selfDismiss : false;
  const [dismissed, setDismissed] = React.useState(false);
  const closeClickHandler = e => {
    onCloseClick?.(e);
    if (selfDismiss) {
      setDismissed(true);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: !dismissed && /*#__PURE__*/(0, _jsxRuntime.jsx)(BaseNotification, {
      classNames: classNames,
      iconLeftName: iconLeftName,
      iconLeftType: iconLeftType,
      semantic: semantic,
      dismissable: dismissable,
      onCloseClick: closeClickHandler,
      testId: testId,
      ref: ref,
      children: children
    })
  });
});